import { render } from "./OopsPage.vue?vue&type=template&id=1a9c1f93&scoped=true"
import script from "./OopsPage.vue?vue&type=script&lang=js"
export * from "./OopsPage.vue?vue&type=script&lang=js"

import "./OopsPage.vue?vue&type=style&index=0&id=1a9c1f93&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9c1f93"]])

export default __exports__